import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import type { Notification } from "../../domain/Notification";
import type { ReminderChannelsResponse } from "./reminderChannels.mapper";

export const NotificationsAPI = {
    // The server reads the therapist from the token, never from the request.
    get_unread: (): Promise<AxiosResponse<Notification[]>> =>
        apiClient.get(`/notifications`),

    mark_as_read: (notification_id: string): Promise<AxiosResponse<Notification>> =>
        apiClient.put(`/notifications/${notification_id}/read`),

    // The wire shape: `readReminderChannels` turns it into the domain's channels.
    reminder_channels: (): Promise<AxiosResponse<ReminderChannelsResponse>> =>
        apiClient.get(`/notifications/reminder-channels`),
};
